module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/main-5e55ba78862310661a539437ff16bfb5.png";